// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterGuarantorInvitationsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetGuarantorInvitesWebApiResponseDto,
  InviteGuarantorWebApiRequestDto,
  InviteGuarantorWebApiResponseDto,
  RemoveGuarantorWebApiRequestDto,
} from '../..';

interface GetGuarantorInvitesParams {
  applicationId: string;
}

export const CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvites_Path =
  '/api/web/renter/v1/guarantor/getGuarantorInvites';

export const CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvites = (
  getParams: GetGuarantorInvitesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetGuarantorInvitesParams, never, GetGuarantorInvitesWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvites_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor_Path =
  '/api/web/renter/v1/guarantor/inviteGuarantor';

export const CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor = (
  postData: InviteGuarantorWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, InviteGuarantorWebApiRequestDto, InviteGuarantorWebApiResponseDto>(
    {
      endpoint: CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor_Path =
  '/api/web/renter/v1/guarantor/removeGuarantor';

export const CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor = (
  postData: RemoveGuarantorWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RemoveGuarantorWebApiRequestDto, void>(
    {
      endpoint: CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
